import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_69c3hdlc0m: FaireBrandEntity = {
  token: "b_69c3hdlc0m",
  type: "brand",
  name: "SAMUEL DONG",
  avatarUrl:
    "https://cdn.faire.com/fastly/e8404855d55519c779bd3c0a96e988ef71d06c5930f2ad3a8a18621d325ce1f5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e7a111ed40fb3605912354640d6edebd010232b6c41ffde4fbef82ec2faecc8f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e8404855d55519c779bd3c0a96e988ef71d06c5930f2ad3a8a18621d325ce1f5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e7a111ed40fb3605912354640d6edebd010232b6c41ffde4fbef82ec2faecc8f.jpeg",
  location: "Passaic, NJ, USA",
  minimumOrderDollars: 200,
  rating: 4.5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "The company was established in 1996 and Samuel created his own brand SAMUEL DONG in New York city in 2001. Since he launched Bubble coat style #11664 in Hong Kong fashion week in July 2006, bubble coats/dresses are his signature products. Solid, Prints, Jacquard, Brocade as many as possible. It is still very hot in bubble coat/dress. He designs Spring and Fall/Resort two seasons each year, beside coat/dress, coming jackets, pants, skirts, denims as well each season. His styles are missy cut, contemporary look, size coming XXS(2/4), XS(4/6), S(6/8), M(10/12), L(12/14), XL(14/16), XXL(16/18), XXXL(18/20). He keeps inventory in New Jersey, USA, SAMUEL DONG team will ship out the order if you place the order by 2:00pm Monday to Friday except USA national holidays.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:57.744Z",
    importedBy: "entity-db-cli",
  },
};
